module.exports = "https://www.gc-qa.gnp.com.mx/e973f8e1b6e14d1f1c5bda743d6a353c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/directorio/4.png
// module id = 1025
// module chunks = 0 1